module.exports = __webpack_public_path__ + "img/1300_Red_Flags_Exercise-background.8e0a83e5.png";